import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error_027958f2aabecab9ce9fc221a9548388",
  "use": "error_027958f2aabecab9ce9fc221a9548388-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"error_027958f2aabecab9ce9fc221a9548388\">\n    <path fill-rule=\"nonzero\" d=\"M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM7 3.5v6h2v-6H7zm0 7v2h2v-2H7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol